
<template>
  <component
    :is="icon"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth" :default-class="defaultClass"
  />
</template>

<script>
import * as icons from "lucide-vue-next";

export default {
	name: "lucide-icon",
	props:{
    name: {
    type: String,
    required: true
  },
  size: Number,
  color: String,
  strokeWidth: Number,
  defaultClass: String
    },

	data() {
		return {
      
        }
	},
	created(){

	},
	methods: {

	},
	computed: {
    icon(){
      return icons[this.name]
    }

	},
	watch: {
	}
}

</script>
